module.exports = __webpack_public_path__ + "static/media/5.6e846951.jpeg";